import {DotFillIcon} from '@primer/octicons-react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'
import iconStyles from '../../Icon.module.css'

export function NotReadyStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (
    status !== EffectiveEntryStatus.NotReady &&
    status !== EffectiveEntryStatus.MergeConflicts &&
    status !== EffectiveEntryStatus.NeedsRebase
  ) {
    return null
  }

  return <DotFillIcon size={12} className={`color-fg-attention ${iconStyles.scaledDot}`} />
}
